const config = {
    terminal: 1, // 终端
    title: '管理系统', //   网站默认标题
    version: '1.0.0', //    版本号
    baseUrl: `/`, //    请求接口域名
    fullBaseUrl: `http://192.168.80.40:8188/`, // 现没用？   `http://127.0.0.1:8787/`,
    // appId: process.env.APP_ID, //   appId
    urlPrefix: 'adminapi', //   请求默认前缀
    timeout: 60 * 1000, //   请求超时时长
    token_key: 'token' //   token key
}
export default config



// WEBPACK FOOTER //
// ./src/config/index.js